import _ from 'lodash';
import { Component, DestroyRef, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  selectVirtualEventData,
  selectVirtualEventSelectedCampaign,
  selectVirtualEventSelectedOption
} from '../../../features/data/data.selectors';
import { of } from 'rxjs';
import {combineAll, map} from 'rxjs/operators';
import { CAMPAIGN_TYPE } from '../../../virtual-event.enums';
import {selectAuctioneerLayoutHeight} from '../../../../core/features/layout.selectors';
import {selectVirtualEventSummary} from '../../../features/summary/summary.selectors';
import {selectActiveCampaignList} from '../../../../campaign/features/campaign.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-current-campaign-info',
  templateUrl: './current-campaign-info.component.html',
  styleUrls: ['./current-campaign-info.component.scss']
})
export class CurrentCampaignInfoComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public campaign$: any = this.store.pipe(select(selectVirtualEventSelectedCampaign));
  public event$: any = this.store.pipe(select(selectVirtualEventData));
  public option$: any = this.store.pipe(select(selectVirtualEventSelectedOption));
  public summary$: any = this.store.pipe(select(selectVirtualEventSummary));
  public list$: any = this.store.pipe(select(selectActiveCampaignList));

  @ViewChild('defaultTemplate', {static: true})
    private defaultTemplateRef: TemplateRef<any>;
  @ViewChild('auctionTemplate', {static: true})
    private auctionTemplateRef: TemplateRef<any>;
  @ViewChild('donateTemplate', {static: true})
    private donateTemplateRef: TemplateRef<any>;
  @ViewChild('lastHeroTemplate', {static: true})
    private lastHeroTemplateRef: TemplateRef<any>;

  public selectedTemplateRef: TemplateRef<any> = null;

  public height$: any = this.store.pipe(
    select(selectAuctioneerLayoutHeight),
    map(height => {
      return height < 164 ? 164: height;
    })
  );

  constructor(
    private store: Store<any>,
  ) {
  }

  ngOnInit(): void {
    of(this.event$, this.campaign$, this.option$, this.summary$, this.list$).pipe(
      combineAll(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((results) => {
      const event: any = results[0];
      const campaign: any = results[1];
      const option: any = results[2];


      const currentItemType = _.get(event, 'currentItem.currentItemType', 1);
      if (currentItemType === 1) {
        this.selectedTemplateRef = this.defaultTemplateRef;
        return;
      }

      switch (campaign.type) {
        case CAMPAIGN_TYPE.AUCTION:
          this.selectedTemplateRef = this.auctionTemplateRef;
          break;
        case CAMPAIGN_TYPE.DONATE:
          this.selectedTemplateRef = this.donateTemplateRef;
          break;
        case CAMPAIGN_TYPE.LAST_HERO:
          this.selectedTemplateRef = this.lastHeroTemplateRef;
          break;
        default:
          this.selectedTemplateRef = this.defaultTemplateRef;
          break;
      }
    });
  }

  calculateRaisedValue(summary, selectedCampaign): number {
    const list = _.get(summary, 'byCampaign', []);
    const filteredList = _.filter(list, campaign => {
      return _.isEqual(campaign.campaignData.id, selectedCampaign.id);
    });
    return _.sumBy(filteredList, campaign => {
      return campaign.pendingAmount + campaign.donatedAmount;
    });
  }

  isNotEmpty(campaign) {
    return !_.isEmpty(campaign);
  }

  getContext(event, campaign, option, summary, height, list) {
    const raised = this.calculateRaisedValue(summary, campaign);
    return {event, campaign, option, raised, height, list};
  }

  getImageUrl(option) {
    return option.imageUrl === '' ? '/images/org_logo_default_v2.svg' : option.imageUrl;
  }
}
